import { z } from "zod";
import { EstadosPlanificacionProductiva } from "@/constants/enums/status/entity-status-ids";
import { Option } from "@/components/select/AsyncAutocompleteSelect";
export type CultivoFormItem = {
  idGrano?: string[];
  hectareasAsembrar?: string;
  fechaEstimadaSiembra?: string;
  consumoPropio?: string;
  consumoPropioPicado?: string;
  costoEstimado?: string | number;
  toneladasRinde?: string;
};

export type ProductPlanificationCreationForm = {
  account?: Option | null;
  idUsuarioMobile?: any;
  idCampana?: string[];
  idZonaProductiva?: string[];
  haPropias?: string;
  haAlquiladas?: string;
  detalle?: string;
  cultivos: CultivoFormItem[];
};

export interface ProductPlanificationListItem {
  id: number;
  estado?: string;
  cuentaOrigen?: number;
  titularCuenta?: string;
  idCampana?: number;
  campana?: string;
  hectareasPropias?: number;
  hectareasAlquiladas?: number;
  fechaCreacion?: string;
  nombreCultivo?: string;
  desvioHectareas?: boolean;
}

export interface ProductPlanificationListResponse {
  data: ProductPlanificationListItem[];
  totalPages: number;
  totalRecords: number;
}

export const productPlanificationDefaultFilters = {
  cuentaOrigen: null,
  cultivos: [],
  estados: [
    EstadosPlanificacionProductiva.Cargada,
    EstadosPlanificacionProductiva.Presentada,
    EstadosPlanificacionProductiva.DatosEnRevision,
  ].map(String),
  conDesvioHectareas: "",
  hectareasPropias: "",
  hectareasAlquiladas: "",
};

export const productPlanificationFiltersSchema = z.object({
  cuentaOrigen: z.any().optional(),
  cultivos: z.any().optional(),
  estados: z.any().optional(),
  conDesvioHectareas: z.any().optional(),
  hectareasPropias: z.any().optional(),
  hectareasAlquiladas: z.any().optional(),
});
